import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

// Acknowledges an action that has already completed, listing what it did.
// Takes the place of a success snackbar where the outcome is worth reading.
export default function SuccessDialog({ open, onClose, title, details = [] }) {
    return (
        <Dialog
            onClose={onClose}
            aria-labelledby="success-dialog-title"
            open={open}
            fullWidth
            maxWidth="xs"
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 3,
                        overflow: "hidden",
                    },
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1.5,
                    px: { xs: 2, sm: 3 },
                    py: 2.5,
                }}
            >
                <Box
                    sx={{
                        width: 42,
                        height: 42,
                        borderRadius: 2,
                        display: "grid",
                        placeItems: "center",
                        flexShrink: 0,
                        color: "primary.main",
                        backgroundColor: "action.hover",
                    }}
                >
                    <CheckCircleOutlineIcon />
                </Box>
                <Typography
                    id="success-dialog-title"
                    variant="h5"
                    component="h2"
                    sx={{ flex: 1, minWidth: 0, lineHeight: 1.1 }}
                >
                    {title}
                </Typography>
                <IconButton
                    aria-label="Close confirmation"
                    onClick={onClose}
                    sx={{ mt: -0.75, mr: -1 }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>

            {details.length > 0 && (
                <DialogContent
                    dividers
                    sx={{
                        p: { xs: 2, sm: 2.5 },
                        backgroundColor: "background.default",
                    }}
                >
                    <Box
                        sx={{
                            p: { xs: 1.5, sm: 2 },
                            borderRadius: 2.5,
                            border: "1px solid",
                            borderColor: "divider",
                            backgroundColor: "background.paper",
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                        }}
                    >
                        {details.map((detail) => (
                            <Box
                                key={detail}
                                sx={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: 1,
                                    minWidth: 0,
                                }}
                            >
                                <CheckIcon
                                    fontSize="small"
                                    sx={{
                                        color: "primary.main",
                                        flexShrink: 0,
                                        mt: 0.15,
                                    }}
                                />
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{
                                        minWidth: 0,
                                        lineHeight: 1.5,
                                        overflowWrap: "anywhere",
                                    }}
                                >
                                    {detail}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </DialogContent>
            )}

            <DialogActions sx={{ px: { xs: 2, sm: 3 }, py: 1.5 }}>
                <Button onClick={onClose} variant="contained" disableElevation>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}
